import { Dialog, Transition } from '@headlessui/react';
import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import { getAuthorizationHeader, http } from '../../config/http';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { IconAdjustmentsHorizontal, IconX, IconTrash, IconXboxX } from '@tabler/icons-react';
import LoadingIndicator from '../LoadingIndicator';

export default function HapusBanyakBarang({
  setOpenHapusBanyakBarang,
  refreshPage,
  reloadDate,
  openHapusBarangBanyak,
  cabang,
  setSelectedItems,
  selectedItems,
  resetSelectPindahItems,
  closeModalBanyakBarang,
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false);
  const ids = selectedItems.map((item) => item.id);
  const [selectCabang, setSelectCabang] = useState([]);
  const [idCabang, setIdCabang] = useState(0);


  // useEffect(() => {
  //   async function getCabangSelect() {
  //     await http
  //       .get(`cabang/brankas`, {
  //         headers: { Authorization: getAuthorizationHeader() },
  //       })
  //       .then((res) => {
  //         setSelectCabang(res.data.data);
  //       })
  //       .catch((err) => {
  //         if (err.response === 'undefined') {
  //           return null;
  //         } else if (err.response.status === 401) {
  //           navigate('/login');
  //         }
  //       });
  //   }
  //   getCabangSelect();
  // }, [navigate]);

  // const [cabangId, setCabangId] = useState(0);

  async function handleSubmitHapusBanyakBarang(e) {
    e.preventDefault();
    setLoading(true);
    const formData = {
      items: ids
      // cabang_id: cabangId
    }
    // if (cabangId !== 0) {
    try {
      const response = await http.post('/item/hapus-multi', formData, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      // console.log(response.data)
      toast.success('Data berhasil dihapus', { autoClose: 600, });
      setOpenHapusBanyakBarang(false);
      setIsOpenModalConfirm(false);
      reloadDate();
      setLoading(false);
      resetSelectPindahItems();
      return response.data
    } catch (error) {
      console.log(error);
    }
    // } else {
    //   toast.error('Pilih toko dulu', { autoClose: 600, });
    // }
    setLoading(false);
  }
  
  // async function handleSubmitPindahBarang(e) {
  //   e.preventDefault();
  //   setLoading(true);
  //   const formData = {
  //     cabang_id: idCabang,
  //     items: ids,
  //   };
  //   // if (idCabang !== 0) {
  //   try {
  //     const response = await http.post('/item/transfer', formData, {
  //       headers: { Authorization: getAuthorizationHeader() },
  //     });
  //     // console.log(response.data)
  //     toast.success('Data berhasil dihapus', { autoClose: 600, });
  //     setOpenHapusBanyakBarang(false);
  //     refreshPage();
  //     setLoading(false);
  //     return response.data
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   // } else {
  //   //   toast.error('Pilih cabang tujuan', { autoClose: 600, });
  //   // }
  //   setLoading(false);
  // }

  function fake() { }
  function removeSelectedItem(itemId) {
    setSelectedItems(currentItems => currentItems.filter(item => item.id !== itemId));
  }
  return (
    <>
      {loading &&
        <LoadingIndicator />
      }
      <Transition appear show={openHapusBarangBanyak} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={fake}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden bg-white dark:bg-slate-900 sm:rounded-xl p-0 text-left align-middle shadow-xl transition-all flex flex-col max-h-[90vh] border dark:border-slate-800">
                  {/* Header */}
                  <div className="px-5 py-3 border-b border-slate-200 dark:border-slate-700/60 bg-white dark:bg-slate-900 flex items-center justify-between sticky top-0 z-10 w-full">
                    <div>
                      <Dialog.Title as="h2" className="text-lg sm:text-xl font-bold text-slate-800 dark:text-slate-100">
                        Hapus Banyak Barang
                      </Dialog.Title>
                      <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">Akan menghapus {ids?.length} barang sekaligus</p>
                    </div>
                    <button
                      onClick={closeModalBanyakBarang}
                      className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 dark:hover:text-slate-300 transition-colors"
                    >
                      <IconX className="w-5 h-5" />
                    </button>
                  </div>

                  {/* Body / Scrollable Content */}
                  <div className="p-5 overflow-y-auto flex-1 bg-slate-50/50 dark:bg-slate-900/50">
                    <div className="bg-white dark:bg-slate-900 border text-center border-slate-200 dark:border-slate-700/60 rounded-lg overflow-hidden shadow-sm">
                      <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left text-slate-600 dark:text-slate-300">
                          <thead className="text-xs text-slate-500 dark:text-slate-400 uppercase bg-slate-50 dark:bg-slate-800/80 border-b border-slate-200 dark:border-slate-700/60">
                            <tr>
                              <th scope="col" className="px-3 py-2 font-semibold w-12 text-center">No</th>
                              <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 align-middle">Kode</th>
                              <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 align-middle">Barang</th>
                              <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 text-right align-middle">Berat</th>
                              <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 text-center w-20">Aksi</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                            {selectedItems?.length === 0 ? (
                              <tr>
                                <td colSpan="5" className="px-3 py-6 text-center text-slate-400 dark:text-slate-500">Belum ada barang dipilih</td>
                              </tr>
                            ) : (
                              selectedItems?.map((bt, i) => (
                                <tr key={i} className="hover:bg-red-50/50 dark:hover:bg-red-900/10 transition-colors bg-white dark:bg-slate-900">
                                  <td className="px-3 py-1.5 text-center text-slate-400 dark:text-slate-500">{i + 1}</td>
                                  <td className="px-3 py-1.5 font-medium border-l border-slate-200 dark:border-slate-700/60 align-middle text-slate-700 dark:text-slate-300">{bt?.kode_item}</td>
                                  <td className="px-3 py-1.5 border-l border-slate-200 dark:border-slate-700/60 align-middle text-slate-600 dark:text-slate-400 truncate max-w-[150px]">{bt?.jenis_kategori?.nama_jenis}</td>
                                  <td className="px-3 py-1.5 border-l border-slate-200 dark:border-slate-700/60 align-middle text-right tabular-nums text-slate-700 dark:text-slate-300">{bt?.berat} gr</td>
                                  <td className="px-3 py-1.5 border-l border-slate-200 dark:border-slate-700/60 align-middle text-center">
                                    <button
                                      type="button"
                                      onClick={() => removeSelectedItem(bt.id)}
                                      className="inline-flex items-center justify-center w-7 h-7 rounded-lg text-slate-400 dark:text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-600 dark:hover:text-slate-300 transition-colors"
                                      title="Batal Hapus"
                                    >
                                      <IconX className="w-5 h-5" />
                                    </button>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Footer / Actions */}
                  <div className="px-5 py-4 border-t border-slate-200 dark:border-slate-700/60 bg-white dark:bg-slate-900 flex flex-col sm:flex-row justify-end gap-3 sticky bottom-0 w-full z-10">
                    <button
                      type="button"
                      disabled={loading}
                      onClick={closeModalBanyakBarang}
                      className="flex-1 sm:flex-none h-12 sm:h-10 px-6 inline-flex items-center justify-center gap-2 rounded-lg font-semibold text-slate-700 dark:text-slate-300 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 active:bg-slate-300 transition-colors disabled:opacity-50"
                    >
                      Batal
                    </button>
                    <button
                      type="button"
                      disabled={loading || selectedItems?.length === 0}
                      onClick={() => setIsOpenModalConfirm(true)}
                      className="flex-[2] sm:flex-none h-12 sm:h-10 px-8 inline-flex items-center justify-center gap-2 rounded-lg font-bold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 active:from-amber-600 active:to-amber-700 shadow-md shadow-amber-500/20 transition-all disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:shadow-none disabled:cursor-not-allowed"
                    >
                      {loading ? (
                        <>
                          <div className="w-5 h-5 rounded-full border-2 border-white/30 border-t-white animate-spin"></div>
                          <span>Memproses...</span>
                        </>
                      ) : (
                        <>
                          <IconTrash className="w-5 h-5" />
                          <span>Hapus Barang</span>
                        </>
                      )}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      {/* Modal Konfirmasi Hapus Banyak Barang */}
      <Transition appear show={isOpenModalConfirm} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => !loading && setIsOpenModalConfirm(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-sm transform overflow-hidden rounded-xl bg-white dark:bg-slate-900 p-6 text-left align-middle shadow-xl transition-all border dark:border-slate-800">
                  <div className="flex items-center justify-center mb-4 w-12 h-12 rounded-full bg-amber-100 dark:bg-amber-500/20 mx-auto">
                    <IconTrash className="w-6 h-6 text-amber-600 dark:text-amber-400" />
                  </div>
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-slate-900 dark:text-slate-100 text-center"
                  >
                    Konfirmasi Penghapusan
                  </Dialog.Title>
                  <div className="mt-2 text-center">
                    <p className="text-sm text-slate-500 dark:text-slate-400">
                      Anda yakin ingin secara permanen menghapus <span className="font-bold text-amber-600 dark:text-amber-400">{ids?.length}</span> barang yang dipilih?
                    </p>
                  </div>
                  <div className="mt-6 flex flex-col sm:flex-row gap-3">
                    <button
                      type="button"
                      disabled={loading}
                      className="w-full inline-flex justify-center rounded-xl border border-transparent bg-slate-100 dark:bg-slate-800 px-4 py-2.5 text-sm font-medium text-slate-900 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 focus-visible:ring-offset-2 disabled:opacity-50 transition-colors"
                      onClick={() => setIsOpenModalConfirm(false)}
                    >
                      Batal
                    </button>
                    <button
                      type="button"
                      disabled={loading}
                      className="w-full inline-flex justify-center rounded-xl border border-transparent bg-amber-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-amber-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 shadow-md shadow-amber-500/20 disabled:opacity-50 transition-all"
                      onClick={(e) => {
                        handleSubmitHapusBanyakBarang(e);
                      }}
                    >
                      {loading ? (
                        <div className="flex items-center gap-2">
                          <div className="w-4 h-4 rounded-full border-2 border-white/30 border-t-white animate-spin"></div>
                          <span>Proses...</span>
                        </div>
                      ) : (
                        <span>Ya, Hapus</span>
                      )}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
